import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { ProductCover } from './ProductCover';
const FEATURED = {
  kicker: 'Mega Pack',
  tag: 'Producto destacado',
  title: 'Estética Digital PRO',
  href: 'https://esteticadigital.creativodigital.shop/',
  subtitle: 'Mega Pack para convertir seguidores en pacientes.',
  description: 'Más de 300 recursos editables, guiones de contenido, embudos de captación y prompts de IA para clínicas y profesionales de la estética.',
  bullets: ['300+ recursos editables', 'Embudos listos', 'Prompts de IA']
};
const PRODUCTS = [{
  kicker: 'Recursos de IA',
  scene: 'toolkit' as const,
  title: 'IA Toolkit',
  description: 'Biblioteca de prompts y flujos de automatización para crear contenido en minutos.'
}, {
  kicker: 'Sistema de diseño',
  scene: 'templates' as const,
  title: 'Plantillas Premium',
  description: 'Sistema de plantillas editables para redes, propuestas y landing pages.'
}, {
  kicker: 'Estrategia',
  scene: 'guide' as const,
  title: 'Marketing Playbook',
  description: 'Estrategias paso a paso para lanzar, vender y escalar tu negocio digital.'
}];
const ease = [0.22, 1, 0.36, 1] as const;
export function Products() {
  return <section id="productos" className="relative w-full border-t border-ink/[0.07] bg-white py-28 sm:py-32 lg:py-40" data-id="element-285" data-mp="zx65bjyxcjv2">
      <div className="mx-auto w-full max-w-content px-6 lg:px-8" data-id="element-286" data-mp="13z9hkatf3she">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-287" data-mp="1ro2di7a1i0c0">
          <div className="max-w-2xl" data-id="element-288" data-mp="1wksuqxxkz1z0">
            <p className="text-[12.5px] font-medium uppercase tracking-[0.18em] text-ink-muted" data-id="element-289" data-mp="1wnyhi6iqlrrk">
              Productos
            </p>
            <h2 className="mt-5 text-3xl font-semibold leading-tight tracking-[-0.02em] text-ink sm:text-[2.6rem]" data-id="element-290" data-mp="1mvj0bbf9l77q">
              Recursos digitales listos para usar.
            </h2>
          </div>
          <a href="#contacto" className="inline-flex items-center gap-2 text-sm font-medium text-electric transition-colors hover:text-violetd" data-id="element-291" data-mp="2fcvggnp2x8g4">
            Ver catálogo completo
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-292" data-mp="2l6qsi4tqdfxk" />
          </a>
        </div>

        <motion.article initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.65,
        ease
      }} className="group relative mt-16 overflow-hidden rounded-4xl border border-ink/[0.07] bg-white shadow-soft lg:mt-20" data-id="element-293" data-mp="2g7nmah20l3o0">
          <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
          background: 'radial-gradient(70% 110% at 88% 8%, rgba(37,99,246,0.08), transparent 60%), radial-gradient(60% 100% at 10% 92%, rgba(122,77,255,0.07), transparent 62%)'
        }} data-id="element-294" data-mp="21gn6fqyxu7hu" />
          
        </motion.article>

        <ul className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-295" data-mp="1ijvp3n2yi2gf">
          {PRODUCTS.map((product, i) => <motion.li key={product.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          delay: i * 0.08,
          ease
        }} className="group flex flex-col overflow-hidden rounded-4xl border border-ink/[0.07] bg-white shadow-soft transition-shadow duration-300 hover:shadow-card" data-id="element-296" data-mp="18fyv2li8ztvx" data-mpi={i}>
              <div className="overflow-hidden border-b border-ink/[0.06]" data-id="element-297" data-mp="pnmh11i8f45y">
                <div className="transition-transform duration-700 group-hover:scale-[1.03]" data-id="element-298" data-mp="up26d5rfzwu5">
                  <ProductCover title={product.title} kicker={product.kicker} scene={product.scene} data-id="element-299" data-mp="zm2avc8n8rj5" />
                </div>
              </div>
              <div className="flex flex-1 flex-col p-8 sm:p-9" data-id="element-300" data-mp="6yzd4mbskkty">
                <h3 className="text-[18px] font-semibold tracking-tight text-ink" data-id="element-301" data-mp="6ypn4yqqydo9">
                  {product.title}
                </h3>
                <p className="mt-4 flex-1 text-[14px] font-light leading-relaxed text-ink-muted" data-id="element-302" data-mp="2dmyoxe4sxtyl">
                  {product.description}
                </p>
                <a href="#contacto" className="mt-8 inline-flex items-center justify-center gap-2 rounded-full border border-ink/[0.10] bg-white px-5 py-3 text-sm font-medium text-ink transition-colors duration-300 hover:border-electric/40 hover:text-electric focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric/40" data-id="element-303" data-mp="28pyi3104on6f">
                  Ver Producto
                  <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-304" data-mp="2sb2ynslvmv58" />
                </a>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}